var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg8 = function Svg8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 85,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#8_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.375 36.313c7.469 3.25 11.203 8.937 11.203 17.062 0 6.313-2.344 11.547-7.031 15.703-4.688 4.125-10.578 6.188-17.672 6.188-6.875 0-12.703-2.11-17.484-6.329C2.609 64.688.219 59.517.219 53.422c0-8.125 4.11-13.828 12.328-17.11-7.25-2.468-10.875-7.515-10.875-15.14 0-6.031 2.156-11.016 6.469-14.953C12.484 2.28 17.969.312 24.594.312c6.812 0 12.437 1.938 16.875 5.813C46 10 48.266 14.828 48.266 20.609c0 3.75-.782 6.875-2.344 9.375-1.563 2.5-4.078 4.61-7.547 6.328Zm-8.719 14.953c0-4.875-1.593-7.313-4.781-7.313-.688 0-1.328.188-1.922.563-.562.375-1.062.89-1.5 1.547-.406.656-.734 1.453-.984 2.39-.219.906-.328 1.906-.328 3 0 2.156.437 3.89 1.312 5.203.906 1.282 2.078 1.922 3.516 1.922.687 0 1.312-.172 1.875-.516a4.907 4.907 0 0 0 1.5-1.5c.406-.656.718-1.421.937-2.296.25-.907.375-1.907.375-3Zm-.61-29.063c0-1.906-.374-3.437-1.124-4.594-.75-1.156-1.75-1.734-3-1.734-1.219 0-2.188.547-2.906 1.64-.72 1.094-1.078 2.547-1.078 4.36 0 4.406 1.359 6.61 4.078 6.61 2.687 0 4.03-2.094 4.03-6.282Z",
    fill: "#121213"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#8_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m33.633 36.43 3.854-1.91c3.238-1.604 5.425-3.494 6.739-5.596 1.316-2.106 2.04-4.839 2.04-8.315 0-5.176-1.994-9.455-6.097-12.964l-.008-.007-.008-.007c-4.017-3.507-9.15-5.319-15.56-5.319-6.196 0-11.18 1.828-15.107 5.386-3.88 3.544-5.814 7.985-5.814 13.474 0 3.49.826 6.224 2.343 8.337 1.518 2.113 3.853 3.779 7.177 4.91l5.122 1.745-5.026 2.006c-3.847 1.536-6.583 3.578-8.365 6.05-1.772 2.46-2.704 5.491-2.704 9.202 0 5.49 2.121 10.127 6.498 14.019 4.386 3.868 9.73 5.825 16.158 5.825 6.677 0 12.076-1.929 16.348-5.687 4.254-3.773 6.355-8.46 6.355-14.204 0-3.75-.858-6.803-2.473-9.262-1.614-2.459-4.079-4.466-7.528-5.967l-3.944-1.716Zm8.914 32.648c-4.688 4.125-10.578 6.188-17.672 6.188-6.875 0-12.703-2.11-17.484-6.329C2.609 64.688.219 59.517.219 53.422c0-7.24 3.262-12.556 9.786-15.95a28.005 28.005 0 0 1 2.542-1.16 21.513 21.513 0 0 1-2.573-1.058c-5.535-2.726-8.302-7.42-8.302-14.082 0-6.031 2.156-11.016 6.469-14.953C12.484 2.28 17.969.312 24.594.312c6.812 0 12.437 1.938 16.875 5.813C46 10 48.266 14.828 48.266 20.609c0 3.75-.782 6.875-2.344 9.375-1.217 1.948-3.013 3.658-5.387 5.132a25.89 25.89 0 0 1-2.16 1.197c.778.338 1.515.703 2.211 1.094 5.995 3.366 8.992 8.689 8.992 15.968 0 6.313-2.344 11.547-7.031 15.703Zm-20.683-26.24.021-.013a5.533 5.533 0 0 1 2.99-.872c2.193 0 4.054.89 5.26 2.734 1.11 1.696 1.521 3.987 1.521 6.579 0 1.236-.14 2.41-.44 3.508-.26 1.034-.644 1.989-1.172 2.841l-.011.019-.012.019a6.904 6.904 0 0 1-2.11 2.1l-.012.008-.012.008a5.525 5.525 0 0 1-2.918.81c-2.154 0-3.908-1.013-5.149-2.768l-.016-.022-.015-.023c-1.16-1.742-1.648-3.902-1.648-6.313 0-1.225.122-2.386.384-3.47l.005-.022.006-.023c.288-1.08.685-2.069 1.217-2.928l.017-.029.019-.028c.56-.84 1.24-1.558 2.055-2.102l.02-.013Zm7.417 11.428c.25-.907.375-1.907.375-3 0-4.875-1.593-7.313-4.781-7.313-.688 0-1.328.188-1.922.563-.562.375-1.062.89-1.5 1.547-.406.656-.734 1.453-.984 2.39-.219.906-.328 1.906-.328 3 0 2.156.437 3.89 1.312 5.203.906 1.282 2.078 1.922 3.516 1.922.687 0 1.312-.172 1.875-.516a4.907 4.907 0 0 0 1.5-1.5c.406-.656.718-1.421.937-2.296ZM29.6 16.52c1.026 1.582 1.447 3.532 1.447 5.682 0 2.244-.349 4.27-1.325 5.791-1.073 1.673-2.747 2.49-4.706 2.49-2.011 0-3.695-.875-4.761-2.602-.968-1.568-1.317-3.663-1.317-6.007 0-2.058.405-3.935 1.406-5.458 1.056-1.607 2.629-2.542 4.578-2.542 2.006 0 3.604.99 4.678 2.646Zm-1.678 1.088c.75 1.157 1.125 2.688 1.125 4.594 0 4.188-1.344 6.281-4.031 6.281-2.72 0-4.078-2.203-4.078-6.609 0-1.813.359-3.266 1.078-4.36.718-1.093 1.687-1.64 2.906-1.64 1.25 0 2.25.578 3 1.734Z",
    fill: "#D0DF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "8_svg__a",
    x: 0.219,
    y: 0.313,
    width: 63.359,
    height: 83.953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "8_svg__b",
    x: 0.219,
    y: 0.313,
    width: 63.359,
    height: 83.953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
};
export default Svg8;